import { List } from 'immutable';

import { effectState } from './effects';

export const state = List.of(effectState);
